import { render, staticRenderFns } from "./HaveCaughtCovid.vue?vue&type=template&id=f93400f8&"
import script from "./HaveCaughtCovid.vue?vue&type=script&lang=js&"
export * from "./HaveCaughtCovid.vue?vue&type=script&lang=js&"
import style0 from "./HaveCaughtCovid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports